<script setup lang="ts">
import { useBankTransaction } from '@/core/composables/useBankTransaction'
import { formatToFinnishCurrency } from '@/helpers/formatters'
import { computed, toRef } from 'vue'

interface Props {
  /** The bank transaction to display */
  transaction: BankTransactionResource
}

const { transaction } = defineProps<Props>()

const { isExpense, isIncome } = useBankTransaction(toRef(() => transaction))

const formattedAmount = computed(() =>
  formatToFinnishCurrency(
    isExpense.value ? -transaction.amount : transaction.amount
  )
)
</script>

<template>
  <p
    class="flex flex-row items-center font-medium whitespace-nowrap"
    :class="isIncome ? 'text-success' : 'text-danger'"
  >
    {{ formattedAmount }}
  </p>
</template>
